function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Icon_Hotline",
  "data-name": "Icon Hotline",
  transform: "translate(25.633 17.415) rotate(135)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vereinigungsmenge_2",
  "data-name": "Vereinigungsmenge 2",
  d: "M5.848,25.64c-2.376-.063-3.488-.707-4.345-2.706C-.069,19.265,0,13.232,0,12.824s-.07-6.441,1.5-10.11C2.36.714,3.472.07,5.848.008c4.4-.116,3.8,1.046,3.346,3.976S8.6,7.531,6.458,7.328,3.94,7.972,3.941,9.319c0,1.268,0,3.274,0,3.5s0,2.236,0,3.5c0,1.347.373,2.195,2.517,1.992s2.281.414,2.736,3.344c.434,2.8,1,3.984-2.782,3.984C6.233,25.648,6.046,25.645,5.848,25.64Z",
  transform: "matrix(-0.966, -0.259, 0.259, -0.966, 9.153, 25.645)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1.5
}));

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.069,
    height: 28.992,
    viewBox: "0 0 23.069 28.992",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.23aaf7ee.svg";
export { ForwardRef as ReactComponent };